import React from "react";
import { useSelector } from "react-redux";
import { OverlayTrigger } from "react-bootstrap";
import avatar1 from "../../../assits/avatars/1.jpg";
import { popover } from "../../common/popover/popover";
import ClockComp from "../../table/Clock/ClockComp";

import "./TopPlayer.scss";
function TopPlayer() {
  const cards = useSelector((state) => state.topPlayer.cards);
  const clockActive = useSelector((state) => state.topPlayer.clock);

  return (
    <OverlayTrigger placement="bottom" overlay={popover}>
      <div className="player ptop" data-active="0">
        <div className="bcards">
          <div className="hand">
            {cards.map((card, idx) => (
              <div key={idx}></div>
            ))}
          </div>
        </div>
        <div className="details">
          <i
            className="picture"
            role="img"
            aria-label="profile picture"
            style={{ backgroundImage: `url(${avatar1})` }}
          ></i>
          <b>El Houcine Awixor</b>
          <span>15.925</span>
        </div>
        <div className="estimat dice"></div>
        <div className="clock">
          <ClockComp active={clockActive} />
        </div>
      </div>
    </OverlayTrigger>
  );
}

export default TopPlayer;
